module.exports = __webpack_public_path__ + "img/icon-recieve_money-193.ec03453c.png";